import Cropper from "cropperjs";
import Emitter from "es6-event-emitter";
import {
  ADJUSTED_BOX_CROPPING,
  CLICKED_PRINT_CROPPING,
} from "../../../common/analytics/analyticsevents";
import dictionary from "../../../common/dictionary";
import { requiredParam } from "../../../common/utilities/utils";
import template from "./../templates/cropperComponent.dust";
import { fetchBlob } from "../../../common/utilities/fileDownloader";

export default class CropperComponent extends Emitter {
  constructor(DOMContainer = requiredParam("DOMContainer"), appState, options) {
    super();
    this._DOMContainer = DOMContainer;
    this._appState = appState;
    this._options = options;
    this.render();
  }

  render() {
    const context = {
      i18n: dictionary,
      close: true,
      back: true,
    };
    Dust.render(template, context, (err, result) => {
      this._DOMContainer.innerHTML = result;
      this._imageContainer = document.querySelector("#image-container");
      this.show();
      this._attatchClickHandlers();
    });
  }

  _attatchClickHandlers() {
    this._overlay = this._DOMContainer.querySelector(
      ".cropper-container.overlay-wrapper"
    );
    if (this._overlay) {
      this._overlay.addEventListener("click", this.onOverlayClicked);
    }

    this._closeBtn = document.querySelector(
      ".cropper-nav-item.cropper-nav-back"
    );
    this._closeBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      this.hide();
    });

    this._printBtn = document.querySelector("#crop-print-btn");
    this._printBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      this._appState.triggerEvent(CLICKED_PRINT_CROPPING);
      this.print();
    });
  }

  onOverlayClicked = (e) => {
    if (e.target == this._overlay) {
      this.hide();
      this._appState.trigger("cropper:overlayClicked");
    }
  };

  _removeClickHandlers() {
    this._closeBtn.removeEventListener("click", (e) => {
      e.stopPropagation();
      this.hide();
    });

    this._printBtn.removeEventListener("click", (e) => {
      e.stopPropagation();
      this.print();
    });
  }

  show() {
    if (this._DOMContainer.classList.contains("hidden")) {
      this._DOMContainer.classList.remove("hidden");
    }
  }

  hide() {
    if (!this._DOMContainer.classList.contains("hidden")) {
      this._DOMContainer.classList.add("hidden");
    }
    this._removeClickHandlers();
  }

  loadImage(url) {
    fetchBlob(url)
      .then((blob) => {
        const imageUrl = URL.createObjectURL(blob);
        if (this._imageContainer) {
          this._imageContainer.innerHTML = "";
          const img = document.createElement("img");
          img.src = imageUrl;
          this._imageContainer.appendChild(img);
          this.initializeCropper();
        }
      })
      .catch((error) => {
        console.log("Error loading image:", error); //eslint-disable-line
      });
  }

  initializeCropper() {
    const image = document.querySelector(".cropper-container img");
    if (!image.classList.contains("cropper-hidden")) {
      image.classList.add("cropper-hidden");
    }

    image.addEventListener("cropend", () => {
      this._appState.triggerEvent(ADJUSTED_BOX_CROPPING);
    });

    this.cropper = new Cropper(image, {
      movable: true,
      viewMode: 1,
      autoCropArea: 1,
      rotatable: false,
      scalable: false,
      zoomable: false,
      zoomOnTouch: false,
      zoomOnWheel: false,
      toggleDragModeOnDblclick: false,
      dragMode: "move",
      checkCrossOrigin: false,
    });
  }

  print() {
    const cropData = this.cropper.getData();
    //This will help us create styling specific to text and image printing.
    if (!document.body.classList.contains("imagePrinting")) {
      document.body.classList.add("imagePrinting");
    }
    const printing = document.querySelector("#printing");
    printing.innerHTML = "";
    const container = document.createElement("div");
    container.classList.add("canvas-container");
    printing.appendChild(container);
    const width = cropData.width;
    const height = cropData.height;

    const canvas = this.cropper.getCroppedCanvas({
      width: width * 2,
      height: height * 2,
      fillColor: "#fff",
      imageSmoothingEnabled: true,
      imageSmoothingQuality: "high",
    });

    container.appendChild(canvas);
    window.print();
  }
}



// WEBPACK FOOTER //
// ./src/web/reader/components/cropperComponent.js